import { createContext } from 'react'

export const FeatureFlagsContext = createContext({
  featureFlags: {},
  setFeatureFlags: () => {}
})